import { Chip } from '@mui/material';

/**
 * Neutral BUY/SELL chip — no moral weight (buy != good, sell != bad).
 */
export default function DirectionChip({ direction, size = 'small' }) {
    const isBuy = direction === 'purchase' || direction === 'buy';
    return (
        <Chip
            label={isBuy ? 'BUY' : 'SELL'}
            size={size}
            sx={{
                height: 20,
                fontSize: '0.68rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
                bgcolor: theme =>
                    isBuy ? theme.palette.custom.direction.buyBg : theme.palette.custom.direction.sellBg,
                color: theme =>
                    isBuy ? theme.palette.custom.direction.buyFg : theme.palette.custom.direction.sellFg,
                border: theme =>
                    `1px solid ${
                        isBuy
                            ? theme.palette.custom.direction.buyBorder
                            : theme.palette.custom.direction.sellBorder
                    }`,
            }}
        />
    );
}
